import React, { createContext, useContext, useState, useCallback, useRef, useMemo } from 'react';
import PropTypes from 'prop-types';

const NotificationContext = createContext();

const useNotification = () => useContext(NotificationContext);

const NotificationProvider = ({ children }) => {
  const timer = useRef(null);
  const [notification, setNotification] = useState({
    type: "",
    message: ""
  });
  const [visible, setVisible] = useState(false);

  const hideNotification = useCallback(() => {
    setNotification({ type: "", message: "" });
    setVisible(false);
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);

  const showNotification = useCallback((type, message) => {
    setNotification({ type, message });
    setVisible(true);
    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      hideNotification();
      setNotification({ type: "", message: "" });
    }, 7000);
  }, [hideNotification]);

  const contextValue = useMemo(() => ({ notification, visible, showNotification, hideNotification }), [notification, visible, showNotification, hideNotification]);

  return (
    <NotificationContext.Provider value={contextValue}>
      {children}
    </NotificationContext.Provider>
  );
};
NotificationProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { useNotification, NotificationProvider };